// angular modules
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// components
import { AppComponent } from './app.component';

// components modules
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { HomeModule } from './pages/home/home.module';
import { SharedModule } from './shared/shared.module';
import { DadosModule } from './pages/dados/dados.module';
import { CadastroModule } from './pages/cadastro/cadastro.module';
import { ModalService } from './shared/services/modal.service';
import { registerLocaleData } from '@angular/common';

import ptBr from '@angular/common/locales/pt';
registerLocaleData(ptBr);

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { contabilidadeReducer } from './store/contabilidade/contabilidade.reducer';
import { ContabilidadeEffects } from './store/contabilidade/contabilidade.effects';
import { unidadeReducer } from './store/unidade/unidade.reducer';
import { UnidadeEffects } from './store/unidade/unidade.effects';
import { ExameEffects } from './store/exame/exame.effects';
import { exameReducer } from './store/exame/exame.reducer';
import { funcionarioReducer } from './store/funcionario/funcionario.reducer';
import { FuncionarioEffects } from './store/funcionario/funcionario.effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { revenueReducer } from './store/revenue/revenue.reducer';
import { RevenueEffects } from './store/revenue/revenue.effects';
import { CondicionalEffects } from './store/condicional/condicional.effects';
import { condicionalReducer } from './store/condicional/condicional.reducer';
import { professionalReducer } from './store/professional/professional.reducer';
import { ProfessionalEffects } from './store/professional/professional.effects';
import { professionalServiceReducer } from './store/professional-service/professional-service.reducer';
import { ProfessionalServiceEffects } from './store/professional-service/professional-service.effects';
import { professionalScheduleReducer } from './store/professional-schedule/professional-schedule.reducer';
import { ProfessionalScheduleEffects } from './store/professional-schedule/professional-schedule.effects';
import { FolderEffects } from './store/folder/folder.effects';
import { folderReducer } from './store/folder/folder.reducer';
import { ReportsModule } from './pages/reports/reports.module';
import { deliveryServiceReducer } from './store/delivery-service/delivery-service.reducer';
import { DeliveryServiceEffects } from './store/delivery-service/delivery-service.effects';
import { typeExpensesReducer } from './store/type-expenses/type-expenses.reducer';
import { TypeExpensesEffects } from './store/type-expenses/type-expenses.effects';
import { expensesReducer } from './store/expenses/expenses.reducer';
import { ExpensesEffects } from './store/expenses/expenses.effects';
import { professionReducer } from './store/profession/profession.reducer';
import { ProfessionEffects } from './store/profession/profession.effects';
import { paymentSettingsReducer } from './store/payment-settings/payment-settings.reducer';
import { PaymentSettingsEffects } from './store/payment-settings/payment-settings.effects';
import { customBankReducer } from './store/custom-bank/custom-bank.reducer';
import { CustomBankEffects } from './store/custom-bank/custom-bank.effects';
import { cashExpensesReducer } from './store/cash-expenses/cash-expenses.reducers';
import { CashExpensesEffects } from './store/cash-expenses/cash-expenses.effects';
import { cashierRevenueReducer } from './store/cashier/cashier.reducers';
import { CashierEffects } from './store/cashier/cashier.effects';
import { employeeReportReducer } from './store/employee-report/employee-report.reducer';
import { EmployeeReportEffects } from './store/employee-report/employee-report.effects';
import { notasFiscaisReportReducer } from './store/notas-fiscais-report/notas-fiscais-report.reducer';
import { NotasFiscaisReportEffects } from './store/notas-fiscais-report/notas-fiscais-report.effects';
import { professionalTransfersReportReducer } from './store/professional-transfers-report/professional-transfers-report.reducer';
import { ProfessionalTransfersReportEffects } from './store/professional-transfers-report/professional-transfers-report.effects';
import { finantialReportReducer } from './store/finantial-report/finantial-report.reducer';
import { FinantialReportEffects } from './store/finantial-report/finantial-report.effects';
import { FinantialReceiptsReportEffects } from './store/finantial-receipts-report/finantial-receipts-report.effects';
import { finantialReceiptsReportReducer } from './store/finantial-receipts-report/finantial-receipts-report.reducer';
import { FinantialExpensesReportEffects } from './store/finantial-expenses-report/finantial-expenses-report.effects';
import { finantialExpensesReportReducer } from './store/finantial-expenses-report/finantial-expenses-report.reducer';
import { bankReducer } from './store/bank/bank.reducer';
import { BankEffects } from './store/bank/bank.effects';
import { JwtModule } from '@auth0/angular-jwt';
import { paymentMachineReducer } from './store/payment-machine/payment-machine.reducer';
import { paymentMachineEffects } from './store/payment-machine/payment-machine.effects';
import { ServiceEffects } from './store/services/service.effects';
import { serviceReducer } from './store/services/service.reducer';
import { InvoiceFeatureModule } from './features/invoice/invoice-feature.module';

export function tokenGetter() {
  return localStorage.getItem("access_token");
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ReactiveFormsModule,
    FormsModule,
    AppRoutingModule,
    CoreModule,
    HomeModule,
    SharedModule,
    InvoiceFeatureModule,
    CadastroModule,
    DadosModule,
    ReportsModule,
    StoreModule.forRoot({
      contabilidade: contabilidadeReducer,
      exame: exameReducer,
      funcionario: funcionarioReducer,
      unidade: unidadeReducer,
      condicional: condicionalReducer,
      revenue: revenueReducer,
      professional: professionalReducer,
      professionalService: professionalServiceReducer,
      professionalSchedule: professionalScheduleReducer,
      service: serviceReducer,
      folder: folderReducer,
      deliveryService: deliveryServiceReducer,
      typeExpenses: typeExpensesReducer,
      profession: professionReducer,

      expenses: expensesReducer,
      paymentSettings: paymentSettingsReducer,
      customBank: customBankReducer,
      bank: bankReducer,
      cashierRevenue: cashierRevenueReducer,

      employeeReport: employeeReportReducer,
      notasFiscaisReport: notasFiscaisReportReducer,
      professionalTransfersReport: professionalTransfersReportReducer,
      finantialReport: finantialReportReducer,
      finantialReceiptsReport: finantialReceiptsReportReducer,
      finantialExpensesReport: finantialExpensesReportReducer,
      paymentMachine: paymentMachineReducer
    }),
    EffectsModule.forRoot([
      ContabilidadeEffects,
      ExameEffects,
      FuncionarioEffects,
      UnidadeEffects,
      RevenueEffects,
      CondicionalEffects,
      ProfessionalEffects,
      ProfessionalServiceEffects,
      ServiceEffects,
      ProfessionalScheduleEffects,
      FolderEffects,
      DeliveryServiceEffects,
      TypeExpensesEffects,
      ExpensesEffects,
      ProfessionEffects,
      PaymentSettingsEffects,
      CashierEffects,
      CustomBankEffects,
      FinantialReportEffects,
      FinantialReceiptsReportEffects,
      FinantialExpensesReportEffects,
      EmployeeReportEffects,
      NotasFiscaisReportEffects,
      ProfessionalTransfersReportEffects,
      BankEffects,
      paymentMachineEffects
    ]),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        disallowedRoutes: [],
      },
    }),
  ],
  bootstrap: [AppComponent],
  providers: [ModalService, { provide: LOCALE_ID, useValue: 'pt' }],
})
export class AppModule {}
